import { render, staticRenderFns } from "./filtersMultiselect.vue?vue&type=template&id=138213db&scoped=true"
import script from "./filtersMultiselect.vue?vue&type=script&lang=js"
export * from "./filtersMultiselect.vue?vue&type=script&lang=js"
import style0 from "./filtersMultiselect.vue?vue&type=style&index=0&id=138213db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138213db",
  null
  
)

export default component.exports